// extracted by mini-css-extract-plugin
export default {"header":"About_header__HTE+i"};